export const FRONTEND_CLIENT_VERSION = '7.0.0';
